// Some common error message generators that are used throughout both apps in error maps.

/**
 * "Name of thing" is required.
 *
 * @param name
 * @returns name + is required
 */
export const isRequired = (name: string) => ({ required: name + ' is required' });

/**
 * "name" must match the pattern "pattern"
 *
 * @param name
 * @param pattern
 * @returns "name" must match the pattern "pattern"
 */
export const mustMatchPattern = (name: string, pattern: string) => ({
  pattern: name + ' must match the pattern ' + pattern
});
